import { useState, useEffect } from "react";
import { PrimaryBtn } from "../button/primary-button";
import {
  saveLocalStorageData,
  getLocalStorageData,
  clearLocalStorageData,
} from "../../helpers/local-storage";
import { search } from "./search";
import { deleteQueryParam } from "@/helpers/set-query-string";

/**
 * Search Component
 * @param {string} placeholder The placeholder for search
 * @param {string} buttonTitle The title of the button
 * @param {boolean} noIcon If we should show icon or not
 * @param {string} icon The name of the icon
 * @param {string} customClass The custom classes for btn
 * @param {string} maxWidth The maximum width of search bar
 * @returns Search Bar
 */
export const SearchBar = ({
  placeholder = "What do you want to learn today?",
  buttonTitle = "Search",
  noIcon,
  icon = "Search",
  customClass = "",
  maxWidth = "540px",
}) => {
  const [searchString, setSearchString] = useState("");
  const [showList, setList] = useState(false);
  const [state, setState] = useState({ results: "" });

  const getUrl = () => {
    if (typeof window !== "undefined") {
      return new URL(window.location.href);
    }
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      handleInput(searchString);
    }, 1000);
    return () => clearTimeout(getData);
  }, [searchString]);

  const handleOnChange = (e) => {
    let searchElem = e.target.value?.length;
    let searchQuery = e.target.value;

    setSearchString(e.target.value);

    if (searchElem > 0) {
      setList(true);
    } else {
      setList(false);
    }
    // handleInput(searchQuery);
  };

  useEffect(() => {
    setList(false);
    let url = getUrl();
    let searchString = url.searchParams.get("q") || ""; //get the search query from the url
    if (searchString) {
      setSearchString(searchString);
    }
  }, []);

  const setTheState = (results) => {
    setState({ results: results });
  };

  const searchOperation = async (options) => {
    const { q, filters, page } = options;
    if (q) {
      const res = await search(q, filters || [], page || 1); //search function from search.js
      return res;
    }
  };

  const handleTimeOut = () => {
    setTimeout(() => {
      clearLocalStorageData("search_results");
    }, 300000);
  };

  const handleInput = async (query) => {
    const options = {
      q: query,
    };

    let sessionKey = "search_q";

    try {
      let res;
      // const cacheData = getSessionData(`${sessionKey}=?q=${query}`);
      const cacheData = getLocalStorageData("search_results");

      if (
        (cacheData === null ||
          cacheData[`${sessionKey}=?q=${query}`] === undefined) &&
        query !== ""
      ) {
        const results = await searchOperation(options);
        res = results;

        let cacheNewResults = getLocalStorageData("search_results") || {};
        cacheNewResults[`${sessionKey}=?q=${query}`] = res;

        saveLocalStorageData("search_results", JSON.stringify(cacheNewResults));
      } else {
        res = cacheData[`${sessionKey}=?q=${query}`];
      }
      setTheState(res);
    } catch (e) {
      // console.log("Error:", e);
    }

    handleTimeOut();
  };

  const handleSearchRoute = () => {
    //will take to the search page
    if (
      typeof window !== "undefined" &&
      searchString.replace(/\s+/g, " ")?.trim()
    ) {
      window.location.href = `/academy/search?q=${searchString}`;
    }
  };

  return (
    <>
      <div
        className={`col-lg-10 col-sm-8 col-8 position-relative pe-0 search-box admy-search-box`}
        style={{ maxWidth: maxWidth }}
        data-swiftype-index="false"
      >
        <input
          type="text"
          className="w-100 admy-search-bar"
          placeholder={placeholder}
          value={searchString}
          onChange={(e) => handleOnChange(e)}
          onKeyDown={(event) => {
            var enteredString = searchString.replace(/\s+/g, " ").trim();
            if (event.key === "Enter" && enteredString?.length > 0) {
              handleSearchRoute();
            }
            if (
              event.keyCode === 40 &&
              showList &&
              state.results?.records?.page.length > 0
            ) {
              event.preventDefault();
              document.querySelector(".suggestions-list a").focus();
            }
          }}
          required
        />
        <button
          type="button"
          aria-label="search"
          onClick={(e) => {
            e.target.previousSibling.value = "";
            setSearchString("");
            setList(false);
            e.target.previousSibling.focus();
            deleteQueryParam("q");
            // deleteQueryParam("filters");
          }}
          style={{
            // backgroundColor: "white",
            position: "absolute",
            top: "50%",
            // "left": "90%",
            right: "1%",
            transform: "translateY(-50%)",
            // "background-color": "white",
            height: "36px",
          }}
        ></button>
        {showList && state.results?.records?.page.length > 0 && (
          <ul
            className="border bg-white suggestions-list text-start"
            style={{ zIndex: "9998", overflowY: "scroll", maxHeight: "300px" }}
          >
            {state.results?.records?.page?.map((searchItem, index) => (
              <a
                href={searchItem.url ? encodeURI(searchItem.url) : "#"}
                className="text-stone-900"
                key={index}
              >
                <li className="py-3">{searchItem.title}</li>
              </a>
            ))}
            <a
              href={`/academy/search?q=${searchString}`}
              className="text-stone-900 fw-bold see-all"
              style={{
                position: "sticky",
                bottom: "0",
              }}
            >
              <li
                className="text-stone-900 py-3 see-all-item"
                style={{ background: "white" }}
              >
                See All
              </li>
            </a>
          </ul>
        )}
      </div>
      {buttonTitle && (
        <div
          className={`col-sm-1 col-4 text-center text-sm-start position-relative admy-search-btn ${customClass}`}
        >
          <PrimaryBtn
            title={buttonTitle}
            icon={noIcon ? "" : icon}
            onClick={() => {
              if (searchString?.length > 0) {
                handleSearchRoute();
              }
            }}
          />
        </div>
      )}
    </>
  );
};
